import { ENV_CONSTANT } from 'constants/enums';
import { BaseRoute } from 'constants/routes';
import { UserManagerSettings } from 'oidc-client-ts';

export const sentinelConfig: UserManagerSettings = {
  // Prod is https://idx.linkhealth.com/auth/realms/developer-platform
  
  authority: `https://idx${
    window._env_.REACT_APP_ENV === ENV_CONSTANT.PRODUCTION ? '' : '-stage'
  }.linkhealth.com/auth/realms/developer-platform`,
  client_id: `CHC-PI-PrepayWebPortal-${
    window._env_.REACT_APP_ENV === ENV_CONSTANT.PRODUCTION ? 'Prod' : 'Dev'
  }`,
  redirect_uri: `${window.location.origin}${BaseRoute}/auth`,
  response_type: 'code',
  scope: 'openid',
  post_logout_redirect_uri: `${window.location.origin}${BaseRoute}/auth`,
  automaticSilentRenew: true,
  silent_redirect_uri: `${window.location.origin}${BaseRoute}/silent-refresh`,
  loadUserInfo: true,
  /*
  extraQueryParams: {
    kc_idp_hint: 'optum-id', //hardwiring OHID as idp_hint
  },
  */
};
